import React from 'react'
import Box from '@mui/material/Box'
import IconButton from '@mui/material/IconButton'
import Brightness7Icon from '@mui/icons-material/Brightness7'
import Brightness4Icon from '@mui/icons-material/Brightness4'
import { DARK } from '../../constants'

export interface BackgroundModeProps {
  theme?: string
  onClick?: () => void
}

const BackgroundMode = (props: BackgroundModeProps) => {
  const { theme, onClick } = props

  return (
    <Box>
      <IconButton sx={{ ml: 1 }} onClick={onClick} color="inherit">
        {theme === DARK ? <Brightness7Icon /> : <Brightness4Icon />}
      </IconButton>
    </Box>
  )
}

export default BackgroundMode
